



























































import { Component, Vue, Ref } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import Sentences from "@/components/cards/Sentences.vue";
import NewSentences from "@/components/modals/NewSentence.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
import { Dialog, Popup, Notify } from "vant";
import axios from "axios";
import Spiner from "@/components/englishjanala/Spiner.vue";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {
    Sentences,
    sidebar,
    NewSentences,
    Spiner,
  },
})
export default class Chapter extends Vue {
  ConvId: any;
  search = "";
  searchResult: any;
  componentKey = 0;
  Spiner: boolean = true;
  chap: any;
  TextChange = "";
  DivId = -1;
  EditId = -1;
  show = false;
  hover: boolean = false;
  whoEn = "";
  sentenceEn = "";
  whoBn = "";
  sentenceBn = "";
  Chapter: any = null;
  sentences: any = "";
  errors: any = [];
  category: any = null;
  ShowEditInput() {
    // chapter.isExpandable = true;
    this.sentences.isExpandable = true;
  }
  NewSentenceInTranslation(sentence: any) {
    this.AddSentence(sentence);

    this.sentences.push({
      id: sentence.sentenceEn,
      en: sentence.sentenceEn,
      bn: sentence.sentenceBn,
      translationType: "EN_2_BN",
      phBn: "",
      whoEn: sentence.whoEn,
      whoBn: sentence.whoBn,
      description: "",
      keywords: [],
      showNarrator: false,
      isBookmarked: false,
      isUserGenerated: false,
      chapterId: "",
      conversationCategoryId: "",
      bookmarkedCategoryName: "",
      isExpandable: false,
      frequency: 0,
      weight: 0,
    });
    sentence.whoBn = sentence.whoEn = sentence.sentenceBn = sentence.sentenceEn = "";
    window.scrollTo(0, document.body.scrollHeight);
  }
  SaveTranslation(u_sentence: any) {
    console.warn("save sent", u_sentence);
    const data = {
      sentence_id: u_sentence.id,
      sentence: {
        id: u_sentence.id,
        en: u_sentence.en,
        bn: u_sentence.bn,
        translationType: "EN_2_BN",
        phBn: "",
        whoEn: u_sentence.whoEn,
        whoBn: u_sentence.whoBn,
        description: "",
        keywords: [],
        showNarrator: false,
        isBookmarked: false,
        isUserGenerated: false,
        chapterId: "",
        conversationCategoryId: "",
        bookmarkedCategoryName: "",
        isExpandable: false,
        frequency: 0,
        weight: 0,

        contributorName: "",
      },
    };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/UpdateSentence",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Sentence is not Updated" });
      });
    Notify({ type: "success", message: "Sentence Updated" });
    // const x = 10;
  }
  AddSentence(new_sentence: any) {
    const data = {
      sentence: {
        id: new_sentence.sentenceEn,
        en: new_sentence.sentenceEn,
        bn: new_sentence.sentenceBn,
        translationType: "EN_2_BN",
        phBn: "",
        whoEn: new_sentence.whoEn,
        whoBn: new_sentence.whoBn,
        description: "",
        keywords: [],
        showNarrator: false,
        isBookmarked: false,
        isUserGenerated: false,
        chapterId: "",
        conversationCategoryId: "",
        bookmarkedCategoryName: "",
        isExpandable: false,
        frequency: 0,
        weight: 0,
        lastUpdatedTime: 0,
        version: 0,
        contributorName: "",
      },
    };
    // get all category list
    // this.$emit("UpdateChapter", this.Chapter[0]);
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/AddSentence",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Sentence is not Added" });
      });
    Notify({ type: "success", message: "Sentence Added" });
  }
  //
  async mounted() {
    const PassData = { offset: 0, limit: 20 };

    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetSentenceList",
      PassData
    );
    const data = response.data;

    this.sentences = data.sentences;
    this.Spiner = false;
  }

  get ConversationId() {
    this.ConvId = this.$route.params.ConversationId;
    return this.$route.params.ConversationId;
  }
  get ChapterId() {
    return this.$route.params.ChapterId;
  }

  get Conversation() {
    return data.conversationCategories.filter((item) => {
      return item.id == this.ConversationId;
    });
  }
  DeleteTranslation(sentenceId: any) {
    const PassId = { sentence_id: sentenceId };
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/DeleteSentence",
        PassId
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Sentence is not Deleted" });
      });
    Notify({ type: "success", message: "Sentence Deleted" });
  }
  get TranslationList() {
    this.componentKey++;
    const PassData = { query: this.search, offset: 0, limit: 50 };
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/SearchSentence",
        PassData
      )
      .then((response) => (this.searchResult = response.data.sentences));

    this.componentKey++; // re-render component
    if (this.search == "") return this.sentences;
    return this.searchResult;
  }
}
